/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type ReportWrapper_report = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReportWrapper_report",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ReportHeader_report",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "AdminReportGrid_report",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "UserReportGrid_report",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "CreateWidgetDialog_report",
      "args": null
    }
  ],
  "type": "Report"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/__generated__/ReportWrapper_report.graphql.js